import AbstractDataModel from '../devices/all/AbstractDataModel';

/*
* Cache of live channels, para combine streams
*/
class RecordingLocalUtil extends AbstractDataModel {
  constructor() {
    super();
  }
}
const channelStreamUtil = new RecordingLocalUtil();
export default channelStreamUtil;


// WEBPACK FOOTER //
// ./src/utils/RecordingLocalUtil.js